import * as Utils from './utils';
import createReducer from '../../../common/util/createReducer';
import {ActionTypes} from '../../actions';
import {downloadFile} from '../../../common/util/file';

const INITIAL_STATE = {
  'checking': false,
  'loading': false,
  'provider': '',
  'transport': '',
  'orderType': '',
  'detail': [],
};

export const providerManualOrder = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.RESTORE_PROVIDER_MANUAL_ORDER]: (state, action) => (INITIAL_STATE),
    [ActionTypes.CHANGE_PROVIDER_MANUAL_ORDER_PARAMETER]: (state, action) => ({
      ...state,
      [action.payload.field]: action.payload.value,
    }),
    [ActionTypes.CHANGE_PROVIDER_MANUAL_ORDER_ALL_PARAMETER]: (state, action) => ({
      ...state,
      ...action.payload.parameters,
    }),
    [ActionTypes.ADD_PROVIDER_MANUAL_ORDER_ELEMENT]: (state, action) => ({
      ...state,
      'detail': Utils.addElement(state.detail),
    }),
    [ActionTypes.REMOVE_PROVIDER_MANUAL_ORDER_ELEMENT]: (state, action) => ({
      ...state,
      'detail': Utils.removeElement(state.detail, action.payload),
    }),
    [ActionTypes.EDIT_PROVIDER_MANUAL_ORDER_ELEMENT_CODE]: (state, actions) => ({
      ...state,
      'detail': Utils.updateElementCode(state.detail, action.payload),
    }),
    [ActionTypes.EDIT_PROVIDER_MANUAL_ORDER_ELEMENT_QUANTITY]: (state, actions) => ({
      ...state,
      'detail': Utils.updateElementQuantity(state.detail, action.payload),
    }),
    [ActionTypes.CHECK_PROVIDER_STOCK_ORDER_CODE_REQUEST]: (state, action) => ({
      ...state,
      'checking': true,
    }),
    [ActionTypes.CHECK_PROVIDER_STOCK_ORDER_CODE_SUCCESS]: (state, action) => ({
      ...state,
      'checking': false,
      'detail': Utils.updateElement(state.detail, action.payload.type, action.response.data),
    }),
    [ActionTypes.CHECK_PROVIDER_STOCK_ORDER_CODE_FAILED]: (state, action) => ({
      ...state,
      'checking': false,
    }),
    [ActionTypes.PROCESS_PROVIDER_MANUAL_ORDER_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.PROCESS_PROVIDER_MANUAL_ORDER_SUCCESS]: (state, action) => {
      downloadFile(action.response.data);
      return INITIAL_STATE;
    },
    [ActionTypes.PROCESS_PROVIDER_MANUAL_ORDER_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.ASK_FOR_PROVIDER_MANUAL_ORDER_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.ASK_FOR_PROVIDER_MANUAL_ORDER_SUCCESS]: (state, action) => {
      return INITIAL_STATE;
    },
    [ActionTypes.ASK_FOR_PROVIDER_MANUAL_ORDER_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
  })(state, action);
};
